import { render, staticRenderFns } from "./block-image1200.vue?vue&type=template&id=54ea030d"
import script from "./block-image1200.vue?vue&type=script&lang=js"
export * from "./block-image1200.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports